export interface IDepartmentOptionSource {
  id: string
  name: string
  parentId?: string | null
}

export interface IDepartmentOption {
  id: string
  name: string
  level: number
}

export function buildDepartmentOptions(teams: IDepartmentOptionSource[]): IDepartmentOption[] {
  const knownIds = new Set(teams.map((team) => team.id))
  const childrenByParent = new Map<string, IDepartmentOptionSource[]>()
  const roots: IDepartmentOptionSource[] = []

  for (const team of teams) {
    if (team.parentId && knownIds.has(team.parentId)) {
      const siblings = childrenByParent.get(team.parentId) ?? []
      siblings.push(team)
      childrenByParent.set(team.parentId, siblings)
    } else {
      roots.push(team)
    }
  }

  const options: IDepartmentOption[] = []
  const visited = new Set<string>()
  const visit = (team: IDepartmentOptionSource, level: number) => {
    if (visited.has(team.id)) {
      return
    }
    visited.add(team.id)
    options.push({ id: team.id, name: team.name, level })
    for (const child of childrenByParent.get(team.id) ?? []) {
      visit(child, level + 1)
    }
  }
  for (const root of roots) {
    visit(root, 0)
  }
  for (const team of teams) {
    visit(team, 0)
  }

  return options
}

/** Departments as filter options, nested by parentId so a multi-select filter shows sub-departments as groups. */
export function toDepartmentFilterOptions(teams: IDepartmentOptionSource[]): { value: string; label: string; indentLevel: number }[] {
  return buildDepartmentOptions(teams).map((team) => ({ value: team.id, label: team.name, indentLevel: team.level }))
}
